import React, { createContext, useContext, useState,useEffect} from 'react';
import { childrenProps } from 'src/commonTypes/childrenProps';
import {FruitStatusType} from 'src/views/harvesting/fruit-profile/model';


export interface PreferenceType {
    fruitsTab:FruitStatusType,
    fruitsFilter: FruitsFilter
}
export interface PreferenceContextType{
  setFruitsTab: (newFruitsTab:FruitStatusType) => void
  fruitsTab: FruitStatusType
}
export type FruitsFilter = 'New Fish' | 'Old Fish' | 'Blacklist Fish'

const PreferenceContext = createContext({} as PreferenceContextType);

export function usePreferenceContext() {

  return useContext(PreferenceContext);
}

export const PreferenceProvider: React.FC<childrenProps> = ({ children }) => {
  const initialState = JSON.parse(localStorage.getItem('perferenceState')||JSON.stringify({fruitsTab: 'Available'})) as PreferenceType;
  const [perference, setPerference] = useState<PreferenceType>(initialState);

  useEffect(() => {
    localStorage.setItem('perferenceState', JSON.stringify(perference));
  }, [perference]);

  const setFruitsTab = (newFruitsTab:FruitStatusType) =>{
    return setPerference({...perference, fruitsTab:newFruitsTab});
  };
  const fruitsTab = perference.fruitsTab; 

    
  return (
    <PreferenceContext.Provider value={{setFruitsTab,fruitsTab}}>
      {children}
    </PreferenceContext.Provider>
  ); 
};




